/* eslint-disable indent */
import React from "react";
import styles from "../stylesERv2.module.scss";

export const BloqueDTable = ({
  modoCombinado,
  verUltimos12Meses,
  bloqueDCollapsed,
  setBloqueDCollapsed,
  btlMensualesCombinados,
  ingresosBTLMensual,
  monthsToShow,
  openBTLModal,
  formatCurrency,
  formatPercentage,
  ytdIngresosBTL,
  comisionEdificiosBTLMensual,
  ytdComisionEdificiosBTL,
  otrosCostosBTLMensual,
  ytdOtrosCostosBTL,
  margenBTLMensual,
  margenBTLMensualUSD,
  ytdMargenBTL,
  porcentajeSobreFacturacion,
  margenPorcentaje,
  pais,
  verEnDolares,
  ingresosBTLMensualUSD,
  comisionEdificiosBTLMensualUSD,
  otrosCostosBTLMensualUSD,
  // FASE 3 PASO 4c: fuente única Chile+Perú (`construirFilasER`) para las sub-filas de Bloque D
  // en modo combinado — antes esta sección entera se ocultaba (`!modoCombinado`), igual que
  // RRHH/13 cuentas antes de E2b (hallazgo E1 §3a, nunca cerrado para B/D).
  filasCombinado = null,
}) => {
  // FASE 3 PASO 3 (criterio 1), punto 4 — Chile + "Ver en US$": bottom-up ya construido en
  // index.js; Perú sigue con el camino de siempre (10.265/10.267).
  const yaEnUSDChile = pais === "Chile" && verEnDolares;
  const vUSD = (valorChileUSD, valorPeso) => (yaEnUSDChile ? valorChileUSD || Array(12).fill(0) : valorPeso);
  const ingresoMostrado = modoCombinado ? btlMensualesCombinados : vUSD(ingresosBTLMensualUSD, ingresosBTLMensual);
  const comisionMostrada = modoCombinado
    ? filasCombinado["D - BTL & otros / Comisión edificios"].usd
    : vUSD(comisionEdificiosBTLMensualUSD, comisionEdificiosBTLMensual);
  const otrosMostrado = modoCombinado
    ? filasCombinado["D - BTL & otros / Otros costos"].usd
    : vUSD(otrosCostosBTLMensualUSD, otrosCostosBTLMensual);
  return (
    <>
      {/* === BLOQUE D - BTL & otros === */}
      <tr
        className={styles.sectionHeader}
        onClick={() => setBloqueDCollapsed(!bloqueDCollapsed)}
        style={{ cursor: "pointer", userSelect: "none" }}
      >
        <td className={styles.conceptCell}>D - BTL & otros {!verUltimos12Meses && bloqueDCollapsed ? ">" : ""}</td>
        {ingresoMostrado.map((val, i) => (
          <td
            key={i}
            className="text-end"
            onClick={(e) => {
              e.stopPropagation();
              if (!modoCombinado && i < monthsToShow && val > 0) openBTLModal(i);
            }}
            style={{ cursor: !modoCombinado && i < monthsToShow && val > 0 ? "pointer" : "default" }}
          >
            {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado || yaEnUSDChile) : "-"}
          </td>
        ))}
        <td className={styles.totalCell}>
          {formatCurrency(
            ingresoMostrado.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
            null,
            modoCombinado || yaEnUSDChile ? null : ingresosBTLMensual,
            modoCombinado || yaEnUSDChile
          )}{" "}
          |{" "}
          {porcentajeSobreFacturacion(
            modoCombinado ? btlMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) : ytdIngresosBTL
          )}
        </td>
      </tr>

      {!bloqueDCollapsed && (
        <>
          {/* Comisión edificios */}
          <tr>
            <td className={styles.conceptCell}>Comisión edificios</td>
            {comisionMostrada.map((val, i) => (
              <td key={i} className="text-end">
                {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado || yaEnUSDChile) : "-"}
              </td>
            ))}
            <td className={styles.totalCell}>
              {formatCurrency(
                comisionMostrada.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
                null,
                modoCombinado || yaEnUSDChile ? null : comisionEdificiosBTLMensual,
                modoCombinado || yaEnUSDChile
              )}{" "}
              | {ytdIngresosBTL > 0 ? formatPercentage((ytdComisionEdificiosBTL / ytdIngresosBTL) * 100) : "0%"}
            </td>
          </tr>

          {/* Otros costos */}
          <tr>
            <td className={styles.conceptCell}>Otros costos</td>
            {otrosMostrado.map((val, i) => (
              <td
                key={i}
                className="text-end"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!modoCombinado && i < monthsToShow && ingresosBTLMensual[i] > 0) openBTLModal(i);
                }}
                style={{
                  cursor: !modoCombinado && i < monthsToShow && ingresosBTLMensual[i] > 0 ? "pointer" : "default",
                }}
              >
                {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado || yaEnUSDChile) : "-"}
              </td>
            ))}
            <td className={styles.totalCell}>
              {formatCurrency(
                otrosMostrado.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
                null,
                modoCombinado || yaEnUSDChile ? null : otrosCostosBTLMensual,
                modoCombinado || yaEnUSDChile
              )}{" "}
              | {ytdIngresosBTL > 0 ? formatPercentage((ytdOtrosCostosBTL / ytdIngresosBTL) * 100) : "0%"}
            </td>
          </tr>

          {/* Contribución D — en combinado lee `filasCombinado` (fuente única, FASE 3 PASO 4c);
            Chile + "Ver en US$" usa `margenBTLMensualUSD` (bottom-up, ya construido en
            index.js); Perú sigue con el camino de siempre (10.265/10.267). El % siempre se
            mide en pesos. */}
          <tr className={styles.marginRow}>
            <td className={styles.conceptCellMargen}>Contribución</td>
            {(modoCombinado
              ? filasCombinado["D - BTL & otros / Contribución"].usd
              : pais === "Chile" && verEnDolares
                ? margenBTLMensualUSD || margenBTLMensual
                : margenBTLMensual
            ).map((val, i) => (
              <td key={i} className="text-end">
                <div className={val < 0 ? styles.marginNegative : ""}>
                  {i < monthsToShow
                    ? formatCurrency(val, i, null, modoCombinado || (pais === "Chile" && verEnDolares))
                    : "-"}
                </div>
              </td>
            ))}
            <td className={styles.totalCell}>
              {modoCombinado ? (
                (() => {
                  const totalComb = filasCombinado["D - BTL & otros / Contribución"].usd
                    .slice(0, monthsToShow)
                    .reduce((a, b) => a + (b || 0), 0);
                  return (
                    <div className={totalComb < 0 ? styles.marginNegative : ""}>
                      {formatCurrency(totalComb, null, null, true)} |{" "}
                      {margenPorcentaje(
                        totalComb,
                        btlMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0)
                      )}
                    </div>
                  );
                })()
              ) : (
                <div className={ytdMargenBTL < 0 ? styles.marginNegative : ""}>
                  {pais === "Chile" && verEnDolares
                    ? formatCurrency(
                        (margenBTLMensualUSD || margenBTLMensual)
                          .slice(0, monthsToShow)
                          .reduce((a, b) => a + (b || 0), 0),
                        null,
                        null,
                        true
                      )
                    : formatCurrency(ytdMargenBTL, null, margenBTLMensual)}{" "}
                  | {margenPorcentaje(ytdMargenBTL, ytdIngresosBTL)}
                </div>
              )}
            </td>
          </tr>
        </>
      )}
    </>
  );
};
